import styles from "./styles.module.css";

const WaveSpinnerLoader = ({ classNameProps = "", text = "Loading . . ." }) => {
  return (
    <>
      <div className={`${styles.loading} ${classNameProps}`}>
        <span
          className={`${styles.loadingSpan} ${styles.loadingSpan1} bg-primary`}
        ></span>
        <span
          className={`${styles.loadingSpan} ${styles.loadingSpan2} bg-primary`}
        ></span>
        <span
          className={`${styles.loadingSpan} ${styles.loadingSpan3} bg-primary`}
        ></span>
        <span
          className={`${styles.loadingSpan} ${styles.loadingSpan4} bg-primary`}
        ></span>
        <span
          className={`${styles.loadingSpan} ${styles.loadingSpan5} bg-primary`}
        ></span>
      </div>
      <div className="text-center mt-3">{text}</div>
    </>
  );
};

export default WaveSpinnerLoader;
